import React, { useState } from 'react'
import ListLayout from '../../../components/layout/main/ListLayout'
import { PageCard } from '../../../styles/CommonStyles'
import Tabbar from '../../../components/common/tabs/Tabbar'
import AllCards from '../../../components/main/reports/cards/AllCards'
import CardsTransfers from '../../../components/main/reports/cards/CardsTransfers'

const tabs = ['all-cards', 'cards-transfers']

const Cards = () => {
    const [cardsTab, setCardsTab] = useState("all-cards")

    return (
        <ListLayout>
            <PageCard>
                <Tabbar
                    active={tabs.indexOf(cardsTab) + 1}
                    tabs={tabs}
                    onTabClicked={(idx) => setCardsTab(tabs[idx - 1])}
                />
                {cardsTab === "all-cards" &&
                    <AllCards />
                }
                {cardsTab === "cards-transfers" &&
                    <CardsTransfers />
                }
            </PageCard>
        </ListLayout>
    )
}

export default Cards